import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { FileUploadResponse, ApiError } from '../types/showcase';

/**
 * Mutation: POST /api/eraf/showcase/file
 * p95 target < 500ms for 1MB.
 */
export function useFileDemo() {
  return useMutation<FileUploadResponse, ApiError, File>({
    mutationFn: (file) => showcaseApi.uploadFile(file),
    mutationKey: ['common-showcase', 'file'],
  });
}
